import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const FavCtx = createContext(null);
export const useFavorites = () => useContext(FavCtx);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [productIds, setProductIds] = useState(new Set());
  const [materialIds, setMaterialIds] = useState(new Set());

  useEffect(() => {
    if (!user) {
      setProductIds(new Set());
      setMaterialIds(new Set());
      return;
    }
    api
      .get("/favorites/ids")
      .then((r) => {
        setProductIds(new Set(r.data.products || []));
        setMaterialIds(new Set(r.data.materials || []));
      })
      .catch(() => {});
  }, [user]);

  const isFav = useCallback(
    (kind, id) => (kind === "product" ? productIds.has(id) : materialIds.has(id)),
    [productIds, materialIds]
  );

  const toggle = useCallback(
    async (kind, id) => {
      const set = kind === "product" ? productIds : materialIds;
      const already = set.has(id);
      const next = new Set(set);
      if (already) next.delete(id);
      else next.add(id);
      if (kind === "product") setProductIds(next);
      else setMaterialIds(next);
      try {
        if (already) await api.delete(`/favorites/${kind}/${id}`);
        else await api.post("/favorites", { kind, ref_id: id });
      } catch (e) {
        // rollback
        if (kind === "product") setProductIds(set);
        else setMaterialIds(set);
      }
    },
    [productIds, materialIds]
  );

  return (
    <FavCtx.Provider value={{ isFav, toggle, productIds, materialIds }}>
      {children}
    </FavCtx.Provider>
  );
}
